import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
export function StickyCtaBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-126" data-mp="922ucv3w7fy3">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-carbon-700 bg-carbon-900/95 backdrop-blur" data-id="element-127" data-mp="9345ezkws2ft">
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-3 sm:px-8" data-id="element-128" data-mp="2ornrxfvv62zi">
            <div className="min-w-0" data-id="element-129" data-mp="2jx08hvfpvyrs">
              <p className="truncate text-sm font-bold text-white" data-id="element-130" data-mp="166n19pe3wjze">
                La Biblia de las Fallas Típicas
              </p>
              <p className="text-xs text-slate-400" data-id="element-131" data-mp="1a7p1o9jrf22y">
                <span className="font-semibold text-safety" data-id="element-132" data-mp="w98lls00bz85">{PRICE}</span> · PDF de descarga
                inmediata
              </p>
            </div>
            <CtaButton label="Comprar ahora" size="md" className="shrink-0" data-id="element-133" data-mp="115z1ofbtautk" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}